"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Echo__factory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "key",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "value",
                type: "bytes32",
            },
        ],
        name: "Echoed",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "data",
                type: "string",
            },
        ],
        name: "echo",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        name: "publicMapping",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "key",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "val",
                type: "bytes32",
            },
        ],
        name: "setMapping",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
class Echo__factory extends ethers_1.ContractFactory {
    constructor(signer) {
        super(_abi, _bytecode, signer);
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.Echo__factory = Echo__factory;
Echo__factory.bytecode = _bytecode;
Echo__factory.abi = _abi;
